import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {pollPickerEdit_template} from "./pollPickerEdit_template";
import {PollPickerInsertData, pollPickerView_template} from "./pollPickerView_template";

declare var ko: any;

export class pollPicker_template extends vnTemplate {
    protected filterSimple: filterSimple_template;
    public pollEdit: pollPickerEdit_template;
    public pollView: pollPickerView_template;
    protected pollLoadEnabled: boolean = false;
    protected pollNextpageRequested: boolean = false;
    protected pollScrollContainer: HTMLElement | null = null;
    protected pollScrollHandler: EventListener | null = null;
    protected pollScrollDebounceTimeout: number | null = null;
    protected target: any;

    protected getTemplateHtml(): string {
        return /* html */ `
            <div class="w-lightbox w-picker" data-bind="css: { 'is-visible': isShown }">
                <div class="lightbox-content picker">
                    <div class="picker-header w-justify">
                        <div class="w-left"></div>
                        <div class="w-center">
                            <span class="picker-header-title icon i-poll">Poll Search</span>
                        </div>
                        <div class="w-right">
                            <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }"></button>
                        </div>
                    </div>

                    <div class="picker-body">
                        <div class="list-header w-justify">
                            <div class="w-left">
                                <button class="btn icon i-poll" type="button" data-bind="event: { click: onClickAddPoll }">Create Poll</button>
                                <button class="btn secondary icon i-poll" type="button" data-bind="event: { click: onClickGenerateAndEditPoll }">Generate & Edit</button>
                                <button class="btn secondary icon i-ins" type="button" data-bind="event: { click: onClickGenerateAndInsertPoll }">Generate & Insert</button>
                            </div>
                            <div class="w-right">
                                ${this.filterSimple.getHtmlBuild()}
                            </div>
                        </div>

                        <div class="w-picker-list" id="poll-results-list" style="max-height: calc(100vh - 220px); overflow-y: auto; min-height: 0;">
                            <div class="" data-bind="css: { 'is-visible': pollResults().length == 0 && !isLoading(), 'w-msg': (pollResults().length > 0 || isLoading()) }">
                                <p>No Results Found</p>
                            </div>

                            <ul class="picker-list" id="poll-picker-list" data-bind="foreach: pollResults, css: { loading: isLoading }" style="height: auto; min-height: 12rem;">
                                <li class="picker-item icon">
                                    <button class="btn-zone view" title="view poll" type="button" data-bind="event: { click: $parent.onClickPoll }"><span>view poll</span></button>
                                    <button class="btn-zone icon i-edit" style="right: 42px; bottom: 6px; z-index: 69; font-size: 16px;" title="Quick Edit Poll" type="button" data-bind="event: { click: $parent.onClickQuickEditPoll }"><span>edit poll</span></button>
                                    <button class="btn-zone icon i-ins" style="right: 6px; bottom: 6px; z-index: 69; font-size: 16px;" title="Quick Insert Poll" type="button" data-bind="event: { click: $parent.onClickQuickInsertPoll }"><span>insert poll</span></button>
                                    <div class="w-info">
                                        <strong data-bind="text: name"></strong>
                                        <span>
                                            <span data-bind="text: questions ? questions.length : (numberOfQuestions || 0)"></span> questions
                                            &nbsp;|&nbsp;
                                            <span data-bind="text: numberOfRespondents"></span> respondents
                                        </span>
                                        <span data-bind="visible: dateCreated, text: dateCreated.slice(0, 16)"></span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>

                    ${this.pollView.getHtmlBuild()}
                    ${this.pollEdit.getHtmlBuild()}
                </div>
            </div>
        `;
    }

    protected buildViewModel(): any {
        const self = this;
        return {
            isShown: ko.observable(false),
            isLoading: ko.observable(false),
            target: ko.observable(""),
            pollResults: ko.observableArray([]),
            pollElement: ko.observable(null),
            pollPagination: {
                pageNumber: ko.observable(1),
                pageMax: ko.observable(1),
                itemPerPage: 54,
            },
            orderBy: ko.observable("dateCreated"),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("dateCreated_DESC"),
            onClickCancel: () => self.hide(),
            onClickPoll: (poll) => self.onClickPoll(poll),
            onClickQuickEditPoll: (poll) => self.onClickQuickEditPoll(poll),
            onClickQuickInsertPoll: (poll) => self.onClickQuickInsertPoll(poll),
            onClickAddPoll: () => self.onClickAddPoll(),
            onClickGenerateAndEditPoll: () => self.onClickGenerateAndEditPoll(),
            onClickGenerateAndInsertPoll: () => self.onClickGenerateAndInsertPoll(),
        };
    }

    protected initPartial(): void {
        this.pollView = new pollPickerView_template("pollPickerView", this.getTemplateViewModel(), this.caller);
        this.pollView.setParent(this);

        this.pollEdit = new pollPickerEdit_template("pollPickerEdit", this.getTemplateViewModel(), this.caller);
        this.pollEdit.setParent(this);

        this.filterSimple = new filterSimple_template("filterPollSearch", this.getTemplateViewModel(), this);
    }

    protected getTemplateName(): string {
        return "pollPicker-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    public getViewModelForRequest() {
        return {
            filters: {
                keywords: this.getTemplateViewModel().filterPollSearch.filterKeyword,
            },
            pagination: this.getTemplateViewModel().pollPagination,
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
        };
    }

    public resetPagination(): void {
        this.disablePollWaypoint();
        this.getTemplateViewModel().pollPagination.pageNumber(1);
        this.getTemplateViewModel().pollPagination.pageMax(1);
        this.getTemplateViewModel().pollResults([]);
        this.pollNextpageRequested = false;

        const div = document.getElementById("poll-results-list");
        if (div) {
            div.scrollTop = 0;
        }
    }

    public setSimpleFilterKeyword(filterKeyword): void {
        this.getTemplateViewModel().filterPollSearch.filterKeyword(filterKeyword || "");
    }

    public setTarget(target): void {
        this.target = target;
        this.getTemplateViewModel().target(target);
    }

    public setPollElement(pollElement): void {
        this.getTemplateViewModel().pollElement(pollElement);
    }

    public getPollElement() {
        return this.getTemplateViewModel().pollElement();
    }

    public getIdBrand(): number | null {
        const appZone = this.caller.getVnAppZone ? this.caller.getVnAppZone() : null;
        if (appZone && appZone.app && appZone.app.params && appZone.app.params.idBrand) {
            return Number(appZone.app.params.idBrand);
        }

        return this.caller.getBrandId ? Number(this.caller.getBrandId()) : null;
    }

    public setPollResults(polls): void {
        if (this.getTemplateViewModel().pollPagination.pageNumber() == 1) {
            this.getTemplateViewModel().pollResults([]);
        }

        if ((polls || []).length > 0) {
            const pollResults = this.getTemplateViewModel().pollResults().concat(polls);
            this.getTemplateViewModel().pollResults(pollResults);
            this.pollNextpageRequested = false;
            this.enablePollWaypoint();
            return;
        }

        this.pollNextpageRequested = false;
    }

    public setPollsPagination(totalPage, currentPage): void {
        this.getTemplateViewModel().pollPagination.pageMax(totalPage);
        this.getTemplateViewModel().pollPagination.pageNumber(currentPage);
    }

    public show(): void {
        if (!document.body.classList.contains("is-fixed")) {
            document.body.classList.add("is-fixed");
        }
        this.getTemplateViewModel().isShown(true);
    }

    public hide(): void {
        this.disablePollWaypoint();
        document.body.classList.remove("is-fixed");
        this.pollView.hide();
        this.pollEdit.hide();
        this.getTemplateViewModel().isShown(false);
    }

    public showLoading(): void {
        this.getTemplateViewModel().isLoading(true);
    }

    public hideLoading(): void {
        this.getTemplateViewModel().isLoading(false);
    }

    public enablePollWaypoint(): void {
        if (this.pollLoadEnabled) {
            return;
        }

        const div = document.getElementById("poll-results-list");
        if (!div) {
            return;
        }

        this.pollScrollContainer = div;
        this.pollScrollHandler = () => {
            if (this.pollScrollDebounceTimeout !== null) {
                window.clearTimeout(this.pollScrollDebounceTimeout);
            }

            this.pollScrollDebounceTimeout = window.setTimeout(() => {
                this.pollScrollDebounceTimeout = null;
                this.handlePollResultsScroll(div);
            }, 150);
        };

        div.addEventListener("scroll", this.pollScrollHandler);
        this.pollLoadEnabled = true;
    }

    protected disablePollWaypoint(): void {
        if (this.pollScrollDebounceTimeout !== null) {
            window.clearTimeout(this.pollScrollDebounceTimeout);
            this.pollScrollDebounceTimeout = null;
        }

        if (this.pollScrollContainer && this.pollScrollHandler) {
            this.pollScrollContainer.removeEventListener("scroll", this.pollScrollHandler);
        }

        this.pollScrollContainer = null;
        this.pollScrollHandler = null;
        this.pollLoadEnabled = false;
    }

    protected handlePollResultsScroll(div: HTMLElement): void {
        const pagination = this.getTemplateViewModel().pollPagination;
        const currentPage = Number(pagination.pageNumber());
        const pageMax = Number(pagination.pageMax());
        const isNearBottom =
            div.scrollTop > 0 &&
            div.scrollTop + div.clientHeight >= div.scrollHeight - 100;

        if (
            !this.getTemplateViewModel().isShown() ||
            !document.body.classList.contains("is-fixed") ||
            !isNearBottom ||
            this.pollNextpageRequested ||
            currentPage >= pageMax
        ) {
            return;
        }

        this.pollNextpageRequested = true;
        pagination.pageNumber(currentPage + 1);

        if (this.caller.getPollData) {
            this.caller.getPollData();
        } else {
            this.pollNextpageRequested = false;
        }
    }

    protected filterSimpleOnChange(): void {
        this.resetPagination();
        this.caller.getPollData();
    }

    protected filterSimpleCancel(): void {
        if (this.caller.filterSimpleCancel) {
            this.caller.filterSimpleCancel();
        }
    }

    protected onClickPoll(poll): void {
        if (this.caller.getPollForPicker) {
            this.caller.getPollForPicker(poll.id);
            return;
        }

        this.setPoll(poll);
    }

    protected onClickQuickEditPoll(poll): void {
        if (this.caller.getPollForPicker) {
            this.caller.getPollForPicker(poll.id, true);
            return;
        }

        this.editPoll(poll);
    }

    protected onClickQuickInsertPoll(poll): void {
        this.insertPoll({
            idPoll: poll.id,
            pollName: poll.name || "Poll",
            isWithTitle: !!poll.isWithTitle,
            isDynamicPlacement: this.getInitialPollDynamicPlacement(),
        });
    }

    protected onClickAddPoll(): void {
        this.pollView.hide();
        this.editPoll(this.getNewPollFromCurrentArticle());
    }

    /**
     * Only switches to the edit form once generation has succeeded: ArticlePollGenerationService
     * rejects articles under its minimum content length, and the picker's list should stay visible
     * (with the error popup) rather than open an empty edit form for a draft that failed.
     */
    protected onClickGenerateAndEditPoll(): void {
        this.pollView.hide();
        this.generatePollFromArticle(this.getNewPollFromCurrentArticle());
    }

    /**
     * Only closes the picker once the initial insert/validate round trip has succeeded: a source
     * article under pollController::getOrCreateForArticle's minimum content length leaves the
     * picker open on its list with the error popup already shown by insertGeneratedPollFromPicker,
     * instead of closing on a request that inserted nothing.
     */
    protected async onClickGenerateAndInsertPoll(): Promise<void> {
        if (!this.caller.insertGeneratedPollFromPicker) {
            return;
        }

        const isInserted = await this.caller.insertGeneratedPollFromPicker(
            this.target || "article_content",
            this.getInitialPollDynamicPlacement()
        );

        if (!isInserted) {
            return;
        }

        this.setPollElement(null);
        this.pollView.hide();
        this.pollEdit.hide();
        this.hide();
    }

    protected getNewPollFromCurrentArticle() {
        const sourceArticle = this.getCurrentArticleForPoll();
        const idBrand = this.getIdBrand();

        return {
            id: null,
            name: "",
            description: "",
            idReferenceArticle: sourceArticle ? sourceArticle.id : null,
            idReferenceBrand: sourceArticle ? sourceArticle.idBrand : idBrand,
            referenceArticle: sourceArticle,
            brandResults: [],
            questions: [],
            sections: [],
        };
    }

    protected getCurrentArticleForPoll() {
        if (this.caller.getCurrentArticleForQuizPicker) {
            return this.caller.getCurrentArticleForQuizPicker();
        }

        return null;
    }

    protected getInitialPollDynamicPlacement(): boolean {
        const elementToReplace = this.getPollElement();
        if (elementToReplace && elementToReplace.getAttribute("data-dynamic-placement") !== null) {
            return elementToReplace.getAttribute("data-dynamic-placement") === "1";
        }

        try {
            const settings = this.caller.articlesEdit.getTemplateViewModel().articlePageSettings();
            return !!(settings && settings.isPollDynamicPlacementOnByDefault);
        } catch (e) {
            return false;
        }
    }

    protected getInitialPollIsWithTitle(poll): boolean {
        const elementToReplace = this.getPollElement();
        if (elementToReplace && elementToReplace.getAttribute("data-poll-is-with-title") !== null) {
            return elementToReplace.getAttribute("data-poll-is-with-title") === "1";
        }

        return !!(poll && poll.isWithTitle);
    }

    public insertPoll(pollData: PollPickerInsertData): void {
        const elementToReplace = this.getPollElement();
        this.caller.insertPollPlaceholder(this.target, pollData, elementToReplace);
        this.setPollElement(null);
        this.pollView.hide();
        this.pollEdit.hide();
        this.hide();
    }

    public editPoll(poll): void {
        this.pollEdit.setBrandId(this.getIdBrand());
        this.pollEdit.setPoll(poll);
        this.pollEdit.setIsWithTitle(this.getInitialPollIsWithTitle(poll));
        this.pollEdit.show();
    }

    public savePoll(poll, insertAfterSave = false, isDynamicPlacement = null): void {
        this.caller.savePollFromPicker(poll, insertAfterSave, isDynamicPlacement);
    }

    /**
     * @param draftPoll Base fields for a fresh poll to switch the edit form to once generation
     * succeeds (the "Generate & Edit" picker button). Omitted when regenerating from within an
     * already open edit form (the "Generate based on article" button), which keeps its current state.
     */
    public generatePollFromArticle(draftPoll: any = null): void {
        this.caller.generatePollFromArticleFromPicker(draftPoll);
    }

    public generateCommercialSignals(): void {
        this.caller.generateCommercialSignalsFromPicker();
    }

    public exportPoll(): void {
        this.caller.exportPollFromPicker();
    }

    public setPoll(poll): void {
        this.pollView.setPoll(poll);
        this.pollView.setIsWithTitle(this.getInitialPollIsWithTitle(poll));
        this.pollView.setIsDynamicPlacement(this.getInitialPollDynamicPlacement());
        this.pollEdit.setBrandId(this.getIdBrand());
        this.pollEdit.setPoll(poll);
        this.pollEdit.setIsWithTitle(this.getInitialPollIsWithTitle(poll));
        this.pollView.show();
    }

    public setPollAfterSave(poll, insertAfterSave = false, isDynamicPlacement = null): void {
        // Only the edit form can save, so its checkbox holds the freshest choice: read it before the
        // two forms are refilled from the saved poll, which carries the previously stored flag.
        const isWithTitle = this.pollEdit.getIsWithTitle();

        this.updatePollResult(poll);
        this.pollView.setPoll(poll);
        this.pollView.setIsWithTitle(isWithTitle);
        this.pollEdit.setPoll(poll);
        this.pollEdit.setIsWithTitle(isWithTitle);

        if (insertAfterSave) {
            this.insertPoll({
                idPoll: poll.id,
                pollName: poll.name || "Poll",
                isWithTitle: isWithTitle,
                isDynamicPlacement: isDynamicPlacement === null
                    ? this.getInitialPollDynamicPlacement()
                    : !!isDynamicPlacement,
            });
            return;
        }

        this.pollView.show();
        this.pollEdit.hide();
    }

    protected updatePollResult(poll): void {
        const pollResults = this.getTemplateViewModel().pollResults();
        const existingPoll = pollResults.find((result) => result.id == poll.id);

        if (existingPoll) {
            existingPoll.name = poll.name || existingPoll.name;
            existingPoll.questions = poll.questions || existingPoll.questions;
            existingPoll.numberOfRespondents = poll.numberOfRespondents || existingPoll.numberOfRespondents;
            existingPoll.dateCreated = poll.dateCreated || existingPoll.dateCreated;
            this.getTemplateViewModel().pollResults([]);
            this.getTemplateViewModel().pollResults(pollResults);
        } else if (poll && poll.id) {
            this.getTemplateViewModel().pollResults([poll].concat(pollResults));
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/pollPicker_template.ts